import React, { useRef } from "react";
import { PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Typography } from "antd";
import { useReactToPrint } from "react-to-print";
import { useSelector } from "react-redux";

import PurchaseReturnGSTR2Filters from "./components/PurchaseReturnGSTR2Filters";
import PurchaseReturnGSTR2Table from "./components/PurchaseReturnGSTR2Table";
import ReportDom from "../../../components/common/ReportDom";

const { Title } = Typography;

const format = (v) =>
  `₹${Number(v || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
  })}`;

const PurchaseReturnGSTR2 = () => {
  const reportRef = useRef();
  const { message } = App.useApp();

  const { data, filters, loading } = useSelector(
    (state) => state.purchaseReturnGSTR2
  );
  console.log(data, "data");

  const defaultRows = [
    { key: "registered", label: "Purchases Received From Registered taxpayers" },
    { key: "unregistered", label: "Purchases Received From Unregistered taxpayers" },
    { key: "cdn", label: "Details of Credit/Debit Notes/Refund Voucher" },
    { key: "cdn_unreg", label: "Details of Credit/Debit Notes/Refund Voucher for Unregistered Vendor" },
    { key: "overseas_goods", label: "Goods /Capital goods received from Overseas" },
    { key: "overseas_services", label: "Services received from Overseas" },
    { key: "nil", label: "Supplies received from compounding dealer & other exempt/nil/non GST supplies" },
    { key: "hsn", label: "HSN-wise summary of inward supplies" },
    { key: "tds", label: "TDS Credit received" },
    { key: "isd", label: "ISD credit received" },
    { key: "reverse_charge", label: "Inwards Supplies on which tax is to be paid on reverse charge" },
    { key: "advance_paid", label: "Advances paid on account of receipt of supply" },
    { key: "advance_adjusted", label: "Advance adjusted on account of receipt of supply" },
  ];

  const backendMap = Object.fromEntries(
    (data || []).map((item) => [item.key, item])
  );

  const formattedData = defaultRows.map((row) => {
    const match = backendMap[row.key] || {};

    return {
      ...row,
      igst: Number(match.igst || 0),
      cgst: Number(match.cgst || 0),
      sgst: Number(match.sgst || 0),
      taxable: Number(match.taxable || 0),
      total: Number(match.total || 0),
    };
  });

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "GSTR-2",
  });

  const columns = [
    { title: "Description", dataIndex: "label" },
    { title: "IGST Amount", dataIndex: "igst", render: format },
    { title: "CGST Amount", dataIndex: "cgst", render: format },
    { title: "SGST Amount", dataIndex: "sgst", render: format },
    { title: "Taxable Amount", dataIndex: "taxable", render: format },
    { title: "Invoice Total", dataIndex: "total", render: format },
  ];

  return (
    <div style={{ padding: 12 }}>
      <App>
        <Card
          title={<Title level={4}>GSTR-2</Title>}
          extra={
            <Button icon={<PrinterOutlined />} onClick={handlePrint}>
              Print
            </Button>
          }
          style={{ marginBottom: 16 }}
        />

        <PurchaseReturnGSTR2Filters messageApi={message} />

        <Card style={{ marginBottom: 16 }}>
          <PurchaseReturnGSTR2Table
            data={formattedData}
            loading={loading}
          />
        </Card>
      </App>

      <div style={{ position: "absolute", top: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          showTotal={false}
          title="Purchase Return GSTR-2"
          filters={filters}
          columns={columns}
          data={formattedData}
        />
      </div>
    </div>
  );
};

export default PurchaseReturnGSTR2;